import { LoadableAfterPaint } from '@confluence/loadable';

export const ArchiveUpsellDialog = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ArchiveUpsellDialog" */ '../src/ArchiveUpsellDialog.tsx'
			)
		).ArchiveUpsellDialog,
});
